import { render, staticRenderFns } from "./addAdvertiser.vue?vue&type=template&id=5a2f26e2&"
import script from "./addAdvertiser.vue?vue&type=script&lang=js&"
export * from "./addAdvertiser.vue?vue&type=script&lang=js&"
import style0 from "./addAdvertiser.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports